import { useState } from "react";
import ProjectDetailsOptions from "./ProjectDetailsOptions.ui.tsx";

interface UseProjectDetailsOptionsProps {
  onEdit: () => void;
  onDelete: () => void;
  canDelete: boolean;
}

export const useProjectDetailsOptions = ({
  onEdit,
  onDelete,
  canDelete,
}: UseProjectDetailsOptionsProps) => {
  const [show, setShow] = useState(false);

  const open = () => setShow(true);
  const close = () => setShow(false);

  const modal = (
    <ProjectDetailsOptions
      show={show}
      handleClose={close}
      onEdit={onEdit}
      onDelete={onDelete}
      canDelete={canDelete}
    />
  );

  return {
    show,
    open,
    close,
    modal,
  };
};
